import { makeStyles } from "@material-ui/core";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";
import Fab from "@mui/material/Fab";
import Modal from "@mui/material/Modal";
import * as React from "react";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    position: "relative",
    "&:hover $overlayDiv": {
      backgroundColor: "rgba(0,0,0,0.6)",
      transition: "all 0.25s ease-in-out",
      cursor: "pointer",
    },
    "&:hover $overlayContent": {
      visibility: "visible",
    },
    "&:hover $overlayContentPadded": {
      visibility: "visible",
    },
    overflow: "hidden",
  },
  image: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    zIndex: 0,
    cursor: "pointer",
    overflow: "hidden",
  },
  overlayDiv: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0)",
    zIndex: 0,
    transition: "all 0.25s ease-in-out",
    pointerEvents: "none",
  },
  overlayContent: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    visibility: "hidden",
    fontSize: "2rem",
    color: "#FFFFFF",
    padding: "5%",
  },
  overlayContentPadded: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    visibility: "hidden",
    width: "100%",
    height: "100%",
    border: "2px solid #FFFFFF",
  },
  imgContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      display: "flex",
    },
  },
  imgContainer2: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      display: "none",
    },
  },
  abc: {
    width: "100%",
    height: "100vh",
    position: "relative",
  },
  abcinner: {
    width: "100%",
    height: "100vh",
    position: "absolute",
    top: 0,
    right: 0,
    // background: "rgb(30, 30, 30, 0.7)",
  },
  abcinnerinner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "contain",
    width: "100%",
    height: "100vh",
    position: "absolute",
    top: 0,
    left: 0,
  },
  abcImg: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "contain",
    width: "calc(100% - 10rem)",
    height: "100%",
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      width: "85%",
      // height: "80%",
    },
    [theme.breakpoints.up("xs")]: {
      width: "85%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      width: "calc(100% - 10rem)",
    },
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 10rem)",
    },
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 10rem)",
    },
  },
  rightButton: {
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    color: "#ffffff",
    position: "absolute",
    top: "0",
    right: "1rem",
    transform: "scale(1)",
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      top: "6rem",
      right: "4rem",
      transform: "scale(1.8, 0.68)",
    },
    [theme.breakpoints.up("xs")]: {
      top: "8rem",
      right: "4rem",
      transform: "scale(1.6, 0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 94)]: {
      top: "8rem",
      right: "4rem",
      transform: "scale(1.7, 0.9)",
    },
    [theme.breakpoints.up("sm")]: {
      top: "7rem",
      right: "5rem",
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      top: "0rem",
      right: "1rem",
      transform: "scale(1.2)",
    },
    [theme.breakpoints.up("md")]: {
      top: "0",
      right: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      top: "0",
      right: "1rem",
    },
  },
  leftButton: {
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    color: "#ffffff",
    position: "absolute",
    top: "0",
    left: "1rem",
    transform: "scale(1)",
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      top: "6rem",
      left: "4rem",
      transform: "scale(1.8, 0.68)",
    },
    [theme.breakpoints.up("xs")]: {
      top: "8rem",
      left: "4rem",
      transform: "scale(1.6, 0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 94)]: {
      top: "8rem",
      left: "4rem",
      transform: "scale(1.7, 0.9)",
    },
    [theme.breakpoints.up("sm")]: {
      top: "6rem",
      left: "5rem",
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      top: "0rem",
      left: "1rem",
      transform: "scale(1.2)",
    },
  },
  closeButton: {
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    color: "#ffffff",
    position: "absolute",
    top: "1rem",
    transform: "scale(1)",
    left: "calc(100% - 4.5rem)",
    zIndex: 1,
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up("xs")]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up("sm")]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      transform: "scale(1.2)",
    },
  },
}));
const itemData = [
  {
    img: "/images/Gallery/kids_play_area.webp",
    alt: "Kids Play Area",
  },
  {
    img: "/images/Gallery/pool.webp",
    alt: "Swimming Pool",
  },
  {
    img: "/images/Gallery/communityhall.webp",
    alt: "Community Hall",
  },
  {
    img: "/images/Gallery/gym.webp",
    alt: "Gym",
  },
  {
    img: "/images/Gallery/carparking.webp",
    alt: "Car Parking",
  },
  {
    img: "/images/Gallery/Bonfire1.webp",
    alt: "Bonfire",
  },
  {
    img: "/images/Gallery/Terrace_Lounge_area.webp",
    alt: "Terrace Lounge Area",
  },
];
const AmenitiesGall = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedImg, setSelectedImg] = React.useState(itemData[0]);
  const handleOpen = (event, key) => {
    setSelectedImg(itemData[key]);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const classes = useStyles();
  const onChangeImage = (direction) => {
    if (direction === "right") {
      if (itemData.indexOf(selectedImg) === itemData.length - 1) {
        setSelectedImg(itemData[0]);
      } else {
        setSelectedImg(itemData[itemData.indexOf(selectedImg) + 1]);
      }
    }
    if (direction === "left") {
      if (itemData.indexOf(selectedImg) === 0) {
        setSelectedImg(itemData[itemData.length - 1]);
      } else {
        setSelectedImg(itemData[itemData.indexOf(selectedImg) - 1]);
      }
    }
  };
  return (
    <>
      <Modal open={open} onClose={handleClose} className={classes.abc}>
        <div className={classes.abcinner}>
          <Fab
            className={classes.closeButton}
            onClick={() => {
              handleClose();
            }}
          >
            <Close style={{ color: "#ffffff" }} />
          </Fab>
          <div className={classes.abcinnerinner}>
            <Fab
              className={classes.leftButton}
              onClick={() => {
                onChangeImage("left");
              }}
            >
              <ChevronLeft style={{ color: "#ffffff" }} />
            </Fab>
            <img
              src={selectedImg.img}
              alt={selectedImg.alt}
              height={512}
              width={512}
              className={classes.abcImg}
            />
            <Fab
              className={classes.rightButton}
              onClick={() => {
                onChangeImage("right");
              }}
            >
              <ChevronRight style={{ color: "#ffffff" }} />
            </Fab>
          </div>
        </div>
      </Modal>
      <div className={classes.imgContainer}>
        <ImageList cols={3} rowHeight={250} gap={10}>
          {itemData.map((item, key) => (
            <div className={classes.parentDiv} key={key}>
              <ImageListItem />
              <img
                alt={`${item.alt}`}
                src={`${item.img}`}
                loading="lazy"
                className={classes.image}
                onClick={(event) => {
                  handleOpen(event, key);
                }}
              />
              <div className={classes.overlayDiv}>
                <div className={classes.overlayContent}>
                  <div className={classes.overlayContentPadded}>{item.alt}</div>
                </div>
              </div>
            </div>
          ))}
        </ImageList>
      </div>
      <div className={classes.imgContainer2}>
        <ImageList cols={1} rowHeight={180} gap={10}>
          {itemData.map((item, key) => (
            <div className={classes.parentDiv} key={key}>
              <ImageListItem />
              <img
                alt={`${item.alt}`}
                src={`${item.img}`}
                loading="lazy"
                className={classes.image}
                onClick={(event) => {
                  handleOpen(event, key);
                }}
              />
            </div>
          ))}
        </ImageList>
      </div>
    </>
  );
};

export default AmenitiesGall;
